"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { apiFetch, setToken } from "../lib/api";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const router = useRouter();

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    try {
      const resp = await apiFetch<{ token: string }>("/api/login", {
        method: "POST",
        auth: false,
        body: JSON.stringify({ email, password }),
      });

      setToken(resp.token);
      router.push("/properties");
    } catch (e: any) {
      setErr(e.message || "Erro");
    } finally {
      setLoading(false);
    }
  }

  return (
    <main
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        padding: "24px",
        fontFamily: "system-ui",
        background:
          "radial-gradient(circle at 20% 0%, #dbeafe 0%, #eff6ff 30%, #f8fafc 55%, #ffffff 100%)",
      }}
    >
      <section
        style={{
          width: "100%",
          maxWidth: 980,
          display: "grid",
          gridTemplateColumns: "1.1fr 1fr",
          gap: 24,
          alignItems: "stretch",
        }}
      >
        <div
          style={{
            borderRadius: 18,
            padding: 28,
            background: "linear-gradient(145deg, #0f172a, #1e293b)",
            color: "#f8fafc",
            display: "grid",
            alignContent: "space-between",
            minHeight: 440,
          }}
        >
          <div>
            <p style={{ margin: 0, opacity: 0.8, fontSize: 13 }}>FusionCore Learn</p>
            <h1 style={{ margin: "10px 0 8px", fontSize: 36, lineHeight: 1.05 }}>Bem-vindo de volta</h1>
            <p style={{ margin: 0, opacity: 0.9 }}>
              Entre para acessar propriedades, conversas e fluxo de booking.
            </p>
          </div>
          <p style={{ margin: 0, opacity: 0.72, fontSize: 13 }}>
            Ambiente conectado ao backend em <code>learn.fusioncore.com.br</code>
          </p>
        </div>

        <div
          style={{
            border: "1px solid #e2e8f0",
            borderRadius: 18,
            padding: 28,
            background: "#ffffff",
            boxShadow: "0 15px 40px rgba(15, 23, 42, 0.08)",
          }}
        >
          <h2 style={{ margin: "0 0 6px", fontSize: 24 }}>Login</h2>
          <p style={{ margin: "0 0 20px", color: "#475569", fontSize: 14 }}>
            Use seu email e senha para entrar no painel.
          </p>

          <form onSubmit={submit} style={{ display: "grid", gap: 14 }}>
            <label style={{ display: "grid", gap: 6, fontSize: 14 }}>
              Email
              <input
                placeholder="voce@empresa.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{
                  border: "1px solid #cbd5e1",
                  borderRadius: 10,
                  padding: "10px 12px",
                  fontSize: 14,
                }}
              />
            </label>

            <label style={{ display: "grid", gap: 6, fontSize: 14 }}>
              Senha
              <input
                placeholder="Sua senha"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{
                  border: "1px solid #cbd5e1",
                  borderRadius: 10,
                  padding: "10px 12px",
                  fontSize: 14,
                }}
              />
            </label>

            <button
              disabled={loading}
              type="submit"
              style={{
                border: 0,
                borderRadius: 10,
                padding: "11px 14px",
                background: "#0f172a",
                color: "#fff",
                fontWeight: 600,
                cursor: loading ? "not-allowed" : "pointer",
                opacity: loading ? 0.8 : 1,
              }}
            >
              {loading ? "Entrando..." : "Entrar"}
            </button>

            {err && (
              <div
                style={{
                  color: "#b91c1c",
                  background: "#fef2f2",
                  border: "1px solid #fecaca",
                  borderRadius: 10,
                  padding: "10px 12px",
                  fontSize: 14,
                }}
              >
                {err}
              </div>
            )}
          </form>

          <p style={{ opacity: 0.7, marginTop: 16, fontSize: 13 }}>
            Dica: o token fica salvo no localStorage como <code>token</code>.
          </p>
        </div>
      </section>
    </main>
  );
}
